var React = require('react');

function SelfCare (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M22.016 20.853a8.7 8.7 0 1 0-8.5-8.7 8.61 8.61 0 0 0 8.5 8.7Z","fill":"#FFD600","key":0}),React.createElement("path",{"d":"M24.465 18.623a8.79 8.79 0 1 0-8.57-8.79 8.51 8.51 0 0 0 8.57 8.79ZM1.465 45.623h46M26.475 36.782l-2 2-6.42-6.24a4.08 4.08 0 0 1 0-5.81 4.19 4.19 0 0 1 5.94 0l.48.53.47-.53a4.189 4.189 0 0 1 5.94 0 4.08 4.08 0 0 1 0 5.81","stroke":"#2D2D2D","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M21.324 34.103s-4.5 3.62-8.83 2.13c-6.44-2.21.49-17.08 12-17.08 11.48 0 18.41 14.87 12 17.08-4.33 1.49-8.83-2.13-8.83-2.13","stroke":"#2D2D2D","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

SelfCare.defaultProps = {"fill":"none","viewBox":"0 0 48 47"};

module.exports = SelfCare;

SelfCare.default = SelfCare;
